import type { LucideIcon } from "lucide-react";

export function DashboardStatCard({
  icon: Icon,
  label,
  value,
  loading,
}: {
  icon: LucideIcon;
  label: string;
  value: number | null;
  loading: boolean;
}) {
  return (
    <article className="dashboard-metric-card">
      <div className="dashboard-metric-icon"><Icon aria-hidden="true" /></div>
      <div>
        <span>{label}</span>
        {loading ? (
          <i className="dashboard-value-skeleton" aria-label={`Loading ${label}`} />
        ) : (
          <strong>{value === null ? "—" : value.toLocaleString()}</strong>
        )}
        {!loading && value !== null ? <small>Current registered total</small> : null}
      </div>
    </article>
  );
}
